import { formatISO, startOfMonth, subDays } from "date-fns";

import Icon from "components/icon";
import { Link } from "react-router-dom";
import React from "react";
import { UP_RIGHT } from "icons";
import { fetchUnloggedDays } from "components/timesheet/dashboard/banner/api";
import { timesheetKeys } from "components/timesheet/queries";
import { useQuery } from "@tanstack/react-query";

const PendingTimesheetBanner = () => {
  const startDate = formatISO(startOfMonth(new Date()), {
    representation: "date",
  });

  const { data: missedDays, isLoading } = useQuery({
    queryKey: timesheetKeys.thisWeekPayrollHours(startDate),
    queryFn: () => fetchUnloggedDays({ startDate }),
  });

  if (isLoading || !missedDays) return null;
  return (
    <aside
      role="banner"
      aria-label="Product announcement"
      // className="fixed top-16 left-0 right-0 mx-auto px-6"
      className="pt-6 px-6"
    >
      <div className="flex items-center bg-red-50 pl-4 pr-6 py-3 md:py-4 relative rounded-xl  mx-auto">
        <Link
          to="/timesheet/logs/calendar"
          className="flex items-center justify-start gap-2 w-full cursor-pointer"
          aria-label="Learn more about shadcn/ui kit Pro blocks"
        >
          <span className="text-sm text-red-700 hover:underline">
            <span className="font-semibold">Pending Timesheet</span> · You
            haven’t logged your timesheet for{" "}
            {missedDays > 1 ? `${missedDays} days` : "a day"}. Try to fill it
            daily to stay on track
          </span>
        </Link>
        <Link
          className="absolute right-2 w-8 h-8 flex items-center justify-center rounded-md hover:bg-white/10"
          aria-label="Close announcement"
          to="/timesheet/logs/calendar"
        >
          <Icon
            className="size-4 text-red-700"
            aria-hidden="true"
            icon={UP_RIGHT}
          />
          <span className="sr-only">GoTo Log</span>
        </Link>
      </div>
    </aside>
  );
};

export default PendingTimesheetBanner;
